import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Products from '../components/Products';

const slugToType = (slug) => {
  if (!slug) return 'all';
  switch (slug) {
    case 'den-xong-tinh-dau':
      return 'den';
    case 'tinh-dau-thien-nhien':
      return 'tinhdau';
    default:
      return 'all';
  }
};

const ProductsPage = () => {
  const { slug } = useParams();
  const productType = useMemo(() => slugToType(slug), [slug]);
  return (
    <div id="products">
      <Products productType={productType} />
    </div>
  );
};

export default ProductsPage;


